import { render, staticRenderFns } from "./tiwenDialog.vue?vue&type=template&id=27f208d1&scoped=true&"
import script from "./tiwenDialog.vue?vue&type=script&lang=ts&"
export * from "./tiwenDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f208d1",
  null
  
)

export default component.exports